<app-page-layout [overflow]="true">
    <sh-breadcrumbs breadcrumbs>
        <sh-breadcrumb-item [label]="'common.general.home' | translate" href="/"></sh-breadcrumb-item>
        <sh-breadcrumb-item [label]="'common.tasks.requests' | translate" href="/tasks"></sh-breadcrumb-item>
        @if (selectedTab() === TaskTab.CREATED_REQUESTS) {
            <sh-breadcrumb-item
                [label]="'common.tasks.created-requests' | translate"
                href="/tasks"
            ></sh-breadcrumb-item>
        }
        @if (selectedTab() === TaskTab.MDLA_REQUESTS) {
            <sh-breadcrumb-item [label]="'common.tasks.mdla-requests' | translate" href="/tasks"></sh-breadcrumb-item>
        }
        @if (selectedTab() === TaskTab.MY_RESPONSE_NEEDED) {
            <sh-breadcrumb-item
                [label]="'common.tasks.my-response-needed' | translate"
                href="/tasks"
            ></sh-breadcrumb-item>
        }
    </sh-breadcrumbs>

    <h1
        title
        class="text-lg sm:text-2xl font-bold text-shui-text-strong font-sh-bree-headline"
        [innerHTML]="'common.tasks.title' | translate: { name: me()?.firstName }"
    ></h1>

    <div actions>
        <sh-button
            icon="plus"
            icon-position="left"
            size="max-content"
            color="secondary"
            label="{{ 'common.tasks.new-request' | translate }}"
            routerLink="/request"
        ></sh-button>
    </div>

    <div class="flex flex-col w-full gap-2 sm:gap-4">
        <sh-tabs>
            <sh-tab-item
                data-testid="nam-overview-table-tab-created"
                [label]="'common.tasks.created-requests' | translate"
                [attr.active]="selectedTab() === TaskTab.CREATED_REQUESTS ? true : null"
                (click)="selectedTab.set(TaskTab.CREATED_REQUESTS)"
            ></sh-tab-item>
            @if (mode === RequestsMode.TASKS) {
                <sh-tab-item
                    [label]="'common.tasks.mdla-requests' | translate"
                    [attr.active]="selectedTab() === TaskTab.MDLA_REQUESTS ? true : null"
                    (click)="selectedTab.set(TaskTab.MDLA_REQUESTS)"
                ></sh-tab-item>
            }
            @if (mode === RequestsMode.REQUESTS) {
                <sh-tab-item
                    [label]="'common.tasks.my-response-needed' | translate"
                    [attr.active]="selectedTab() === TaskTab.MY_RESPONSE_NEEDED ? true : null"
                    (click)="selectedTab.set(TaskTab.MY_RESPONSE_NEEDED)"
                ></sh-tab-item>
            }
        </sh-tabs>

        <div class="pb-2 sm:pb-3 px-1 sm:px-4 flex-shrink-0">
            <sh-search
                data-testid="nam-overview-filter-input-search"
                [label]="'common.general.search' | translate"
                [rounded]="true"
                [formControl]="activeState().searchControl"
            ></sh-search>
        </div>

        @if (selectedTab() === TaskTab.MDLA_REQUESTS) {
            <div class="px-1 sm:px-4 pb-2 flex-shrink-0">
                <sh-toggle-accessor
                    [label]="'common.tasks.global-search-without-filter' | translate"
                    [attr.active]="activeState().globalSearchActive() ? true : null"
                    (click)="onGlobalSearchToggle(!activeState().globalSearchActive())"
                ></sh-toggle-accessor>
            </div>
        }

        @if (selectedTab() === TaskTab.MDLA_REQUESTS && !activeState().globalSearchActive()) {
            <div class="px-1 sm:px-4 flex-shrink-0">
                <app-request-status
                    [statusOptions]="requestStatusBarOptions"
                    [activeStatuses]="activeState().statusFilterValue()"
                    (activeStatusesChange)="onStatusBarChange($event)"
                ></app-request-status>
            </div>
        }

        @if (!(selectedTab() === TaskTab.MDLA_REQUESTS && activeState().globalSearchActive())) {
            <div
                class="flex items-center gap-2 sm:gap-4 md:gap-8 px-1 sm:px-4 py-2 sm:py-4 mx-0 sm:mx-2 md:mx-6 flex-shrink-0 border-solid border-x-0 border-t-0 border-b border-shui-base-4 overflow-x-auto max-w-screen"
            >
                @if (selectedTab() === TaskTab.MDLA_REQUESTS) {
                    <app-multi-select-filter
                        [label]="'common.general.teams' | translate"
                        [options]="teamOptions()"
                        targetId="team-filter"
                        [value]="activeState().teamFilterValue()"
                        (valueChange)="activeState().teamFilterValue.set($event)"
                    ></app-multi-select-filter>

                    <app-multi-select-filter
                        [label]="'common.tasks.requestor' | translate"
                        [options]="requestorOptions"
                        targetId="requestor-filter"
                        [value]="activeState().requestorFilterValue()"
                        (valueChange)="activeState().requestorFilterValue.set($event)"
                    ></app-multi-select-filter>
                }

                <app-multi-select-filter
                    [label]="'common.general.status' | translate"
                    [options]="statusOptionsForTab()"
                    optionTranslationPrefix="status"
                    targetId="status-filter"
                    [value]="activeState().statusFilterValue()"
                    (valueChange)="onStatusFilterChange($event)"
                ></app-multi-select-filter>

                @if (selectedTab() !== TaskTab.MY_RESPONSE_NEEDED) {
                    <app-multi-select-filter
                        [label]="'common.request-tables.flags' | translate"
                        [options]="flagOptions"
                        targetId="flags-filter"
                        [value]="activeState().flagsFilterValue()"
                        (valueChange)="activeState().flagsFilterValue.set($event)"
                    ></app-multi-select-filter>
                }

                @if (selectedTab() === TaskTab.MDLA_REQUESTS) {
                    <app-multi-select-filter
                        [label]="'common.request-tables.requestor-email' | translate"
                        [options]="activeState().requestorEmailOptions()"
                        targetId="requestor-email-filter"
                        [searchable]="true"
                        [searchPlaceholder]="'common.general.search' | translate"
                        [value]="activeState().requestorEmailFilterValue()"
                        (valueChange)="activeState().requestorEmailFilterValue.set($event)"
                    ></app-multi-select-filter>
                }

                @if (selectedTab() === TaskTab.MDLA_REQUESTS) {
                    <app-multi-select-filter
                        [label]="'common.request-tables.assignee' | translate"
                        [options]="activeState().assigneeOptions()"
                        targetId="assignee-filter"
                        [value]="activeState().assigneeFilterValue()"
                        (valueChange)="activeState().assigneeFilterValue.set($event)"
                    ></app-multi-select-filter>
                }

                @if (selectedTab() !== TaskTab.MY_RESPONSE_NEEDED) {
                    <app-multi-select-filter
                        [label]="'common.request-tables.state' | translate"
                        [options]="stateOptions"
                        optionTranslationPrefix="states"
                        targetId="state-filter"
                        [value]="activeState().stateFilterValue()"
                        (valueChange)="activeState().stateFilterValue.set($event)"
                    ></app-multi-select-filter>
                }

                @if (selectedTab() === TaskTab.MDLA_REQUESTS && showMyAssignedTasksToggle()) {
                    <div class="flex items-center gap-2 ml-auto flex-shrink-0">
                        <sh-toggle-accessor
                            [label]="'common.tasks.only-show-my-assigned-tasks' | translate"
                            [attr.active]="activeState().onlyMyAssignedTasks() ? true : null"
                            (click)="activeState().onlyMyAssignedTasks.set(!activeState().onlyMyAssignedTasks())"
                        ></sh-toggle-accessor>
                    </div>
                }

                @if (
                    selectedTab() === TaskTab.CREATED_REQUESTS &&
                    createdRequestsTable()?.hasSavedRequests() &&
                    !createdRequestsTable()?.selectionMode()
                ) {
                    <sh-button
                        [label]="'common.requests.delete-saved-requests' | translate"
                        color="tertiary"
                        layout="classic"
                        size="max-content"
                        class="ml-auto flex-shrink-0"
                        (click)="createdRequestsTable()?.enterSelectionMode()"
                    ></sh-button>
                }
            </div>

            @if (selectedTab() === TaskTab.CREATED_REQUESTS && createdRequestsTable()?.selectionMode()) {
                <div class="flex items-center justify-between px-4 py-2 flex-shrink-0">
                    <div class="flex items-center gap-3">
                        <sh-checkbox
                            [attr.active]="createdRequestsTable()?.allSavedSelected() ? true : null"
                            (checked)="createdRequestsTable()?.toggleAll(!createdRequestsTable()?.allSavedSelected())"
                        ></sh-checkbox>
                        <span class="text-sm text-shui-text-strong">
                            {{ createdRequestsTable()?.selectedCount() }} selected
                        </span>
                    </div>
                    <div class="flex items-center gap-2">
                        <sh-button
                            [label]="'common.general.confirm' | translate"
                            layout="classic"
                            size="max-content"
                            [disabled]="createdRequestsTable()?.selectedCount() === 0"
                            (click)="createdRequestsTable()?.confirmDelete()"
                        ></sh-button>
                        <sh-button
                            [label]="'common.general.cancel' | translate"
                            layout="classic"
                            color="secondary"
                            size="max-content"
                            (click)="createdRequestsTable()?.cancelSelectionMode()"
                        ></sh-button>
                    </div>
                </div>
            }
        }

        <div class="h-[800px]">
            @switch (selectedTab()) {
                @case (TaskTab.CREATED_REQUESTS) {
                    <app-created-requests-table
                        #createdRequestsTable
                        [tasks]="tasks()"
                        [loading]="loading()"
                        [total]="total()"
                        [activeState]="activeState()"
                        (sortChange)="changeSorting($event.column, $event.order)"
                        (deleteRequests)="deleteSelectedRequests($event)"
                    ></app-created-requests-table>
                }
                @case (TaskTab.MDLA_REQUESTS) {
                    <app-mdla-requests-table
                        [tasks]="tasks()"
                        [loading]="loading()"
                        [total]="total()"
                        [activeState]="activeState()"
                        (sortChange)="changeSorting($event.column, $event.order)"
                        (assigned)="assignToMe($event)"
                    ></app-mdla-requests-table>
                }
                @case (TaskTab.MY_RESPONSE_NEEDED) {
                    <app-my-response-needed-table
                        [tasks]="tasks()"
                        [loading]="loading()"
                        [total]="total()"
                        [activeState]="activeState()"
                        (sortChange)="changeSorting($event.column, $event.order)"
                    ></app-my-response-needed-table>
                }
            }
        </div>
    </div>
</app-page-layout>
